/**
 * Header auth state: Register/Log in ↔ Account
 * Optimistic UI from localStorage avoids guest-button flicker on navigation.
 */
(function () {
  function applyLocal(root) {
    var guest = root.querySelector('[data-auth-guest]');
    var user = root.querySelector('[data-auth-user]');
    var nameEl = root.querySelector('[data-auth-name]');
    var token = window.WinwinApi ? window.WinwinApi.getToken() : '';
    var cachedName = window.WinwinApi ? window.WinwinApi.getCachedName() : '';
    var likelyAuthed = !!token;
    if (guest) guest.hidden = likelyAuthed;
    if (user) user.hidden = !likelyAuthed;
    if (likelyAuthed && nameEl && cachedName) nameEl.textContent = cachedName;
    if (window.WinwinApi) window.WinwinApi.setAuthUi(likelyAuthed);
  }

  async function refresh(root) {
    if (!window.WinwinApi) return;
    applyLocal(root);
    var apiBase = window.WinwinApi.baseFrom(root);
    var guest = root.querySelector('[data-auth-guest]');
    var user = root.querySelector('[data-auth-user]');
    var nameEl = root.querySelector('[data-auth-name]');
    try {
      var res = await window.WinwinApi.request(apiBase, '/session');
      var authed = res.ok && res.data && res.data.authenticated;
      if (guest) guest.hidden = !!authed;
      if (user) user.hidden = !authed;
      if (authed && res.data.user) {
        window.WinwinApi.setAuthUi(true, res.data.user);
        if (nameEl) {
          nameEl.textContent = res.data.user.firstname || res.data.user.name || 'Account';
        }
      } else {
        window.WinwinApi.setToken('');
      }
    } catch (err) {
      console.error('[winwin auth-nav]', err);
    }
  }

  function boot() {
    document.querySelectorAll('[data-auth-nav]').forEach(refresh);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
